import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Auth } from '../services/auth/auth'; // Ajusta la ruta si es necesario
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(Auth); // Inyectamos el servicio
  const router = inject(Router);           // Inyectamos el enrutador

  // Verificamos si el usuario está logueado usando el método que creamos antes
  if (authService.isLoggedIn()) {
    return true; // Tiene token, se le permite el acceso a la ruta
  } else {
    // No tiene token, lo redirigimos al login
    router.navigate(['/login']);
    return false; // Bloqueamos el acceso
  }
};
